import React from 'react'
import { useMediaContext, useParticipants } from '@gopeerproject/web-kit'
import Participant from './Participant'

const LocalParticipant = () => {
  const { room } = useMediaContext()
  const localParticipant = room?.localParticipant
  const participants = useParticipants()

  if (participants.length === 0) return null

  return (
    <div className='gp-Media-localParticipant'>
      <Participant participant={localParticipant} isLocalParticipant={true} />
    </div>
  )
}

export default LocalParticipant
